// extracted by mini-css-extract-plugin
export default {"dropdownLabel":"DropDown__dropdownLabel___gF4vm"};